
















import { Component, Vue, Prop } from 'vue-property-decorator';

type Tab = {
  key: string;
  label: string;
};

@Component({})
export default class AdminTabs extends Vue {
  @Prop({ default: () => [] }) tabs!: Tab[];
  @Prop(String) activeTabKey!: string;
}
